<template>
  <vx-tooltip
    :text="`Канал: ${currentClient.channel}`"
  >
    <button
      class="messenger-close-button"
    >
      <feather-icon
        icon="InfoIcon"
      />
    </button>
  </vx-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['currentClient'])
  }
}
</script>
